/**
 * @Copyright (c) 2021 DigiNet
 * @author NHATLONG
 * @create 15/11/2021
 * @Example
 */


export const types = {
    W05F0012_GET_LIST: 'W05F0012_GET_LIST',
    W05F0012_GET_CBO_EMPLOYEE: 'W05F0012_GET_CBO_EMPLOYEE',
    W05F0012_GET_CBO_CURRENCY: 'W05F0012_GET_CBO_CURRENCY',
    W05F0012_GET_BASE_CURRENCY: 'W05F0012_GET_BASE_CURRENCY',
    W05F0012_GET_DECIMAL_QUANTITY: 'W05F0012_GET_DECIMAL_QUANTITY',
    W05F0012_GET_DECIMAL_QUANTITY_SUCCESS: 'W05F0012_GET_DECIMAL_QUANTITY_SUCCESS',
    W05F0012_GET_CBO_PORTS: 'W05F0012_GET_CBO_PORTS',
    W05F0012_GET_CBO_BANKS: 'W05F0012_GET_CBO_BANKS',
    W05F0012_GET_CBO_MARKING: 'W05F0012_GET_CBO_MARKING',
    W05F0012_GET_CBO_PACKING_TYPE: 'W05F0012_GET_CBO_PACKING_TYPE',
    W05F0012_GET_CBO_PAYMENT_TERM: 'W05F0012_GET_CBO_PAYMENT_TERM',
    W05F0012_SUBCONTRACTNO: 'W05F0012_SUBCONTRACTNO',
    W05F0012_SAVE: 'W05F0012_SAVE',
    W05F0012_EDIT: 'W05F0012_EDIT',

}

export function getList(params, cb) {
    return {
        type: types.W05F0012_GET_LIST,
        params,
        cb
    }
}

export function getCboEmployees(params, cb) {
    return {
        type: types.W05F0012_GET_CBO_EMPLOYEE,
        params,
        cb
    }
}

export function getCboCurrency(params, cb) {
    return {
        type: types.W05F0012_GET_CBO_CURRENCY,
        params,
        cb
    }
}

export function getBaseCurrency(params, cb) {
    return {
        type: types.W05F0012_GET_BASE_CURRENCY,
        params,
        cb
    }
}

export function getDecimalQuantity(params, cb) {
    return {
        type: types.W05F0012_GET_DECIMAL_QUANTITY,
        params,
        cb
    }
}

export function getCboPorts(params, cb) {
    return {
        type: types.W05F0012_GET_CBO_PORTS,
        params,
        cb
    }
}

export function getCboBanks(params, cb) {
    return {
        type: types.W05F0012_GET_CBO_BANKS,
        params,
        cb
    }
}

export function getCboMarking(params, cb) {
    return {
        type: types.W05F0012_GET_CBO_MARKING,
        params,
        cb
    }
}


export function getCboPackingType(params, cb) {
    return {
        type: types.W05F0012_GET_CBO_PACKING_TYPE,
        params,
        cb
    }
}

export function getCboPaymentTerm(params, cb) {
    return {
        type: types.W05F0012_GET_CBO_PAYMENT_TERM,
        params,
        cb
    }
}

export function subContractNo(params, cb) {
    return {
        type: types.W05F0012_SUBCONTRACTNO,
        params,
        cb
    }
}

export function onSave(params, cb) {
    return {
        type: types.W05F0012_SAVE,
        params,
        cb
    }
}

export function onEdit(params, cb) {
    return {
        type: types.W05F0012_EDIT,
        params,
        cb
    }
}
